module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-result-warp column"
  }, [_c('div', {
    staticClass: "game-result-header"
  }, [_c('div', {
    staticClass: "my-btn",
    on: {
      "click": function($event) {
        return _vm.toMy()
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "game-result-info-box column"
  }, [_c('div', {
    staticClass: "anbox"
  }, [_c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.details), function(item, index) {
    return _c('div', {
      staticClass: "tab-item",
      style: (index == _vm.idx ? 'background:#1E7578 !important;color:#fff !important' : ''),
      domProps: {
        "textContent": _vm._s(item.title)
      },
      on: {
        "click": function($event) {
          return _vm.choose(index)
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ascontent m-column"
  }, [_c('div', [_c('echarts', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "id": _vm.id,
      "userid": _vm.ids
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "textword"
  }, [_c('div', {
    staticClass: "wordTitle",
    domProps: {
      "textContent": _vm._s(_vm.details[_vm.idx].inner)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wordtext"
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.details[_vm.idx].text1)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.details[_vm.idx].text2)
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box column column-center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("チャート分析")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5edcb738"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/game/analysis.vue
// module id = 890
// module chunks = 1